'use strict';

import { ISiteSupportedLanguageDto_Props } from './SiteSupportedLanguageDto.if';
import ISiteDto from './SiteDto.if';
import SiteDto from './SiteDto';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';

export interface ISiteSupportedLanguageDto_Linkables {
    site: (db: IModelSource) => Promise<ISiteDto>;
}

function _site(
    this: Partial<ISiteSupportedLanguageDto_Props>,
    db: IModelSource,
): Promise<ISiteDto> {
    return this.siteId
        ? DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto)
        : Promise.reject('Missing field siteSupportedLanguage.siteId');
}

/** 
 * @description all custom properties for
   SiteSupportedLanguageDto & methods to link against other entities
*/
function linkables(
    model: Partial<ISiteSupportedLanguageDto_Props>,
): ISiteSupportedLanguageDto_Linkables {
    return {
        site: _site.bind(model),
    };
}

export default linkables;
